import { render, staticRenderFns } from "./Packaging2.vue?vue&type=template&id=d61fae50&scoped=true&"
import script from "./Packaging2.vue?vue&type=script&lang=js&"
export * from "./Packaging2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61fae50",
  null
  
)

export default component.exports